export default "__VITE_ASSET__DnlQqyEt__"